import { readChoice, rememberValue, userKey } from "../../browserMemory.js";
import { CALENDAR_VIEWS } from "./calendarModel.js";
import type { CalendarView } from "./calendarModel.js";

/**
 * GEDÄCHTNIS DES KALENDERS JE BENUTZER (Spec D23, `browserMemory.ts` mit `userKey`): die Sicht (`ki-calendar-view`) und
 * „Meine | Alle“ (`ki-calendar-tickets`). Nicht gemerkt wird der Anker — die Adresse trägt ihn. Die Quellenwahl teilt der
 * Kalender mit Liste und Zeitachse (`dueSourceMemory.ts`).
 */

const VIEW_KEY = "ki-calendar-view";
const TICKETS_KEY = "ki-calendar-tickets";
const TICKET_CHOICES = ["MINE", "ALL"] as const;

/** Die gemerkte Sicht; Vorgabe Monat, am Telefon Tag. */
export function readCalendarView(userId: string, phone: boolean): CalendarView {
  return readChoice(userKey(VIEW_KEY, userId), CALENDAR_VIEWS, phone ? "DAY" : "MONTH");
}

export function rememberCalendarView(userId: string, v: CalendarView): void {
  rememberValue(userKey(VIEW_KEY, userId), v);
}

/** „Meine“ (`tickets=mine`, Vorgabe) oder „Alle“. */
export function readCalendarTickets(userId: string): "MINE" | "ALL" {
  return readChoice(userKey(TICKETS_KEY, userId), TICKET_CHOICES, "MINE");
}

export function rememberCalendarTickets(userId: string, v: "MINE" | "ALL"): void {
  rememberValue(userKey(TICKETS_KEY, userId), v);
}
